<template>
  <layout-sub-modulo>
    <template #title>Importar datos</template>
    <template #body>
      <div class="py-4 px-4 px-md-16">
        <v-card class="pa-4 mb-6" outlined elevation="1">
          <tarjeta-titulo-paso step="1" title="Descargar plano empleados" />

          <v-divider class="mb-4"></v-divider>

          <v-card-text>
            <v-form
              ref="formCompañia"
              v-model="seleccion.formularioCompañiaValido"
            >
              <v-row class="align-center" dense>
                <v-col cols="12" md="4">
                  <label for="select-compania">Compañía</label>
                  <v-select
                    id="select-compania"
                    v-model="seleccion.compañia"
                    :items="catalogos.empresas"
                    :rules="[reglasValidacion.required]"
                    placeholder="Seleccione una compañía"
                    item-value="nit"
                    item-text="razon_social"
                    return-object
                    outlined
                    dense
                    @change="listarSucursales()"
                  />
                </v-col>

                <v-col cols="12" md="4">
                  <label for="select-sucursal">Sucursal</label>
                  <v-select
                    id="select-sucursal"
                    v-model="seleccion.sucursal"
                    :items="catalogos.sucursales.sucursales"
                    :disabled="seleccion.sucursalDeshabilitada"
                    :rules="[reglasValidacion.required]"
                    placeholder="Seleccione una sucursal"
                    item-value="sucursal_id"
                    item-text="descripcion_sucursal"
                    return-object
                    outlined
                    dense
                    @change="obtenerBancos"
                  />
                </v-col>

                <v-col cols="12" md="3" class="d-flex align-center ml-md-auto">
                  <v-btn
                    color="primary"
                    class="text-none white--text"
                    height="45"
                    block
                    :disabled="
                      !seleccion.formularioCompañiaValido || !seleccion.sucursal
                    "
                    :loading="estaDescargando"
                    depressed
                    @click="descargarExcel()"
                  >
                    <template #loader>
                      <v-progress-circular
                        indeterminate
                        size="18"
                        width="4"
                        color="white"
                        class="mr-2"
                      ></v-progress-circular>
                      <span>Descargando...</span>
                    </template>

                    <v-icon
                      left
                      size="18"
                      color="white"
                      class="material-icons-outlined"
                    >
                      file_download
                    </v-icon>
                    Descargar archivo excel
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>

        <v-card class="pa-4" outlined elevation="1">
          <tarjeta-titulo-paso step="2" title="Importar plano empleados" />

          <v-divider class="mb-4"></v-divider>

          <v-card-text>
            <div>
              <v-form ref="formFile" class="d-none">
                <label for="file-excel">Archivo Excel</label>
                <input
                  id="file-excel"
                  ref="fileExcel"
                  type="file"
                  accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  @change="validarArchivoSeleccionado"
                />
              </v-form>

              <v-sheet
                v-if="!importacion.archivoExcel"
                color="grey lighten-5"
                class="d-flex flex-column align-center justify-center pa-8 mb-6 text-center rounded-lg text-caption"
                :class="{ 'dropzone-activa': estaArrastrando }"
                outlined
                role="button"
                tabindex="0"
                aria-label="Arrastre y suelte su archivo excel o haga clic para seleccionar"
                @dragover.prevent="estaArrastrando = true"
                @dragleave.prevent="estaArrastrando = false"
                @drop.prevent="validarArchivoSoltado"
                @click="$refs.fileExcel.click()"
                @keyup.enter="$refs.fileExcel.click()"
              >
                <v-avatar
                  color="blue lighten-5"
                  size="80"
                  class="mb-3 icono-upload"
                >
                  <v-icon large class="material-symbols-outlined primary--text">
                    cloud_upload
                  </v-icon>
                </v-avatar>

                <div
                  class="body-1 font-weight-bold grey--text text--darken-3 mb-1"
                >
                  Arrastre y suelte su archivo aquí
                </div>
                <div class="caption grey--text text--darken-1 mb-4">
                  O si lo prefiere, haga clic para buscarlo.
                  <br />Solo formatos .xlsx admitidos.
                </div>

                <v-btn
                  color="primary"
                  small
                  outlined
                  class="mt-4"
                  @click.stop="$refs.fileExcel.click()"
                >
                  Seleccionar archivo
                </v-btn>
              </v-sheet>

              <v-card
                v-else
                class="d-flex align-center pa-4 mb-6 rounded-lg grey lighten-5"
                outlined
                :loading="importacion.loading"
                elevation="0"
              >
                <template #progress>
                  <v-progress-linear
                    :active="importacion.loading"
                    color="primary"
                    height="3"
                    indeterminate
                    absolute
                    bottom
                  />
                </template>

                <v-avatar
                  color="green lighten-5"
                  rounded
                  size="48"
                  class="mr-4 flex-shrink-0"
                >
                  <v-icon color="green darken-2">description</v-icon>
                </v-avatar>

                <div class="flex-grow-1">
                  <div
                    class="body-1 font-weight-bold grey--text text--darken-2 text-break"
                  >
                    {{ importacion.archivoExcel.name }}
                  </div>
                  <div
                    class="d-flex align-center green--text text--darken-1 caption mt-1 font-weight-medium"
                  >
                    <v-icon
                      size="16"
                      class="material-symbols-outlined green--text mr-1"
                    >
                      check_circle
                    </v-icon>
                    Listo para subir
                  </div>
                </div>

                <v-btn
                  icon
                  class="btn-eliminar-archivo"
                  :disabled="importacion.loading"
                  @click="eliminarArchivoCargado"
                >
                  <v-icon size="24" class="material-symbols-outlined">
                    delete
                  </v-icon>
                </v-btn>
              </v-card>

              <div
                v-if="importacion.archivoExcel && !importacion.loading"
                class="d-flex justify-end"
              >
                <v-btn
                  color="primary"
                  class="text-none px-6 ml-3"
                  :loading="importacion.loading"
                  :disabled="importacion.loading"
                  @click="procesarArchivo"
                >
                  <v-icon class="material-symbols-outlined mr-2">upload</v-icon>
                  Subir archivo
                </v-btn>
              </div>
            </div>

            <v-row v-if="importacion.errores.length > 0" class="my-6">
              <v-col cols="12">
                <v-data-table
                  :headers="columnasTablaErrores"
                  :items="importacion.errores"
                  :page.sync="pagina"
                  :items-per-page.sync="itemsPorPagina"
                  hide-default-footer
                  class="elevation-1"
                >
                  <template #top>
                    <v-toolbar flat>
                      <v-toolbar-title
                        v-if="!importacion.tieneCambiosPendientes"
                        class="subtitle-1 font-weight-bold"
                      >
                        <v-icon color="warning"> warning </v-icon>
                        Errores del archivo
                      </v-toolbar-title>

                      <v-toolbar-title
                        v-if="importacion.tieneCambiosPendientes"
                        class="subtitle-1 font-weight-bold"
                      >
                        <v-icon color="info" class="mr-2"> info </v-icon>
                        Novedades de los empleados
                      </v-toolbar-title>

                      <v-spacer></v-spacer>

                      <v-btn
                        v-if="importacion.tieneCambiosPendientes"
                        color="primary"
                        small
                        @click="importarEmpleados()"
                      >
                        <v-icon right small class="mr-2">done_all</v-icon>
                        ACEPTAR CAMBIOS
                      </v-btn>
                    </v-toolbar>
                  </template>

                  <template #footer>
                    <data-table-pagination
                      :pagina="pagina"
                      :items-por-pagina="itemsPorPagina"
                      :total-items="totalItemsFiltrados"
                      :loading="importacion.loading"
                      @update:pagina="actualizarPagina"
                      @update:items-por-pagina="actualizarItemsPorPagina"
                    />
                  </template>
                </v-data-table>
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <recomendaciones-importacion
              :tipo-contrato="descripcionTipoContratoIndefinido"
            />
          </v-card-text>
        </v-card>
      </div>
    </template>
  </layout-sub-modulo>
</template>

<script>
import ExcelJS from 'exceljs';
import moment from 'moment';

import { paginacionMixin } from '../../../mixins/paginacionMixin.js';
import { permisosImportarDatosMixin } from '../../../mixins/Permisos/Empleados/importarDatosMixin.js';
import { CONTRATO } from '../../../constants/tipoContrato';
import bancoService from '../../../Services/bancoService';
import empleadosService from '../../../Services/empleadoService';
import empresaService from '../../../Services/empresaService';
import logService from '../../../Services/logService';
import tipoDocumentoService from '../../../Services/tipoDocumentoService';
import tipoContratoService from '../../../Services/tipoContratoService';
import tiposNovedadesService from '../../../Services/tiposNovedadesService';
import usuarioService from '../../../Services/usuarioService.js';
import { getRol } from '../../../utils/permisosUtil.js';
import ConfigErr from '../../../utils/configError.js';
import { hojaAJson } from '../../../utils/excelJsUtil.js';
import {
  construirMapaContratos,
  construirMapaDocumentos,
  estructurarBackend,
  normalizarDatosJson,
} from './helpers/normalizarDatosHelper.js';
import { normalizarNovedadesJson } from './helpers/normalizarNovedadesHelper.js';
import { validarEmpleadoHelper } from './helpers/validarEmpleadoHelper.js';
import { validarNovedadHelper } from './helpers/validarNovedadHelper.js';
import { descargarPlantillaEmpleados } from './reports/datosEmpleados.js';
import {
  alertWarning,
  alertSuccess,
  alertError,
} from '../../../plugins/sweetalert2.js';
import LayoutSubModulo from '../../../components/Layout/SubModulo.vue';
import TarjetaTituloPaso from '../../../components/Empleados/TarjetaTituloPaso.vue';
import DataTablePagination from '../../../components/Table/DataTablePagination.vue';
import RecomendacionesImportacion from './Card/RecomendacionesImportacion.vue';

const INDICE_HOJA_ENCABEZADO = 0;
const INDICE_HOJA_EMPLEADOS = 2;
const INDICE_HOJA_NOVEDADES = 4;

export default {
  components: {
    LayoutSubModulo,
    TarjetaTituloPaso,
    RecomendacionesImportacion,
    DataTablePagination,
  },
  data() {
    return {
      estaArrastrando: false,
      estaDescargando: false,
      seleccion: {
        compañia: null,
        sucursal: null,
        sucursalDeshabilitada: true,
        formularioCompañiaValido: true,
      },
      importacion: {
        archivoExcel: null,
        formularioArchivoValido: true,
        loading: false,
        errores: [],
        tieneCambiosPendientes: false,
      },
      datos: {
        empleadosCargados: [],
        encabezadoCargado: [],
        empleadosSena: [],
        empleadosRetirados: [],
        novedadesCargadas: [],
      },
      catalogos: {
        empresas: [],
        sucursales: [],
        tiposContratos: [],
        tiposDocumentos: [],
        bancos: [],
        tiposNovedades: [],
        mapaContratos: new Map(),
        mapaDocumentos: new Map(),
        nitsValidos: new Set(),
        mapaTiposNovedades: new Map(),
      },
      columnasTablaErrores: [
        { text: 'Hoja', value: 'hoja', align: 'center' },
        { text: '#Línea', value: 'linea', align: 'center' },
        { text: 'Detalle', value: 'detalle', align: 'center' },
      ],
      reglasValidacion: {
        required: value => !!value || 'El campo es obligatorio.',
        size: value =>
          !value ||
          value.size < 5_000_000 ||
          'El tamaño del archivo Excel debe ser inferior a 5MB.',
      },
    };
  },

  computed: {
    datosParaPaginar() {
      return this.importacion.errores;
    },

    descripcionTipoContratoIndefinido() {
      return (
        this.catalogos.tiposContratos.find(contrato => contrato._id === 1)
          ?.DescTipoContrato ?? 'Término indefinido'
      );
    },
  },

  created() {
    this.inicializarCatalogos();
  },

  mixins: [paginacionMixin, permisosImportarDatosMixin],

  methods: {
    async inicializarCatalogos() {
      await Promise.all([
        this.listarTipoDocumentos(),
        this.listarTipoContratos(),
        this.listarEmpresas(),
        this.listarTiposNovedades(),
      ]);
    },

    async listarTipoDocumentos() {
      this.catalogos.tiposDocumentos = await tipoDocumentoService.buscarTodos();

      this.catalogos.mapaDocumentos = construirMapaDocumentos(
        this.catalogos.tiposDocumentos
      );
    },

    async listarTipoContratos() {
      const token = this.$store.state.token;
      const permisoImportarDatos = getRol(
        this.permisosImportarDatos.accesoModulo
      );

      this.catalogos.tiposContratos = await tipoContratoService.buscarTodosConRol(
        token,
        permisoImportarDatos
      );

      this.catalogos.mapaContratos = construirMapaContratos(
        this.catalogos.tiposContratos
      );
    },

    async listarEmpresas() {
      const { empresas = [] } = await usuarioService.getUser(
        this.$store.state.usuario._id
      );

      const empresasNormalizadas = empresas.map(empresa => ({
        ...empresa,
        nit: String(empresa.nit),
      }));

      this.catalogos.nitsValidos = new Set(
        empresas.map(empresa => String(empresa.nit))
      );

      this.catalogos.empresas = empresasNormalizadas;
    },

    async listarSucursales() {
      this.seleccion.sucursal = null;
      this.seleccion.sucursalDeshabilitada = false;
      this.catalogos.sucursales = await empresaService.buscarSucursales(
        this.seleccion.compañia.nit
      );
    },

    async obtenerBancos(forzar = true) {
      if (!forzar && this.catalogos.bancos.length > 0) return;
      const bancos = await bancoService.buscarTodos();
      this.catalogos.bancos = (bancos || []).filter(banco => banco.estaActivo);
    },

    async listarTiposNovedades() {
      const respuesta = await tiposNovedadesService.buscarTodos({
        estaActivo: true,
      });

      const mapaTemporal = new Map();
      respuesta.forEach(({ _id, descripcion }) => {
        mapaTemporal.set(descripcion, _id);
      });

      this.catalogos.tiposNovedades = respuesta;
      this.catalogos.mapaTiposNovedades = mapaTemporal;
    },

    async importarEmpleados() {
      this.importacion.loading = true;
      await this.guardarEmpleados(
        this.datos.empleadosCargados,
        this.datos.encabezadoCargado
      );
      this.importacion.loading = false;
    },

    async guardarEmpleados(empleadoJson, encabezadoJson) {
      const tipoEvento = 'IMPORTAR';
      const descripcionEvento = 'IMPORTA ARCHIVO PLANO';
      const encabezado = encabezadoJson[0];

      const empleadosEstructurados = empleadoJson.map(empleado =>
        estructurarBackend(empleado)
      );

      const data = {
        Empleados: empleadosEstructurados,
        EmpleadosRetirados: this.datos.empleadosRetirados,
        Novedades: this.datos.novedadesCargadas.map(novedad => ({
          numeroDocumento: novedad.numeroDocumento,
          tipoNovedad: String(
            this.catalogos.mapaTiposNovedades.get(novedad.tipoNovedad)
          ),
          fechaInicio: novedad.fechaInicio,
          fechaFin: novedad.fechaFin,
          observacion: novedad.observacion,
        })),
        NitCompañia: encabezado.Nit,
        DescCompañia: encabezado.Compañia,
        IdSucursal: encabezado.IdSucursal,
        DescripcionSucursal: encabezado.Sucursal,
      };
      const response = await empleadosService.sincronizarEmpleados(data);

      if (!Array.isArray(response) || response.length === 0) {
        await alertError('Error al importar empleados');

        return;
      }

      this.limpiarFormulario();
      this.crearLog(tipoEvento, descripcionEvento, encabezado);
      await alertSuccess('Empleados importados correctamente');
    },

    async crearLog(tipoEvento, descripcionEvento, data) {
      const { Nit, Compañia, IdSucursal, Sucursal } = data;
      const { nombre, email } = this.$store.state.usuario;

      const body = {
        NitCompañia: String(Nit),
        DescCompañia: Compañia,
        IdSucursal,
        DescripcionSucursal: Sucursal,
        NombreUser: nombre,
        Email: email,
        DescripcionEvento: descripcionEvento,
        Evento: tipoEvento,
      };

      await logService.crear(body);
    },

    validarArchivoSeleccionado(evento) {
      const archivo = evento.target.files?.[0];
      if (!archivo) return;

      this.importacion.archivoExcel = archivo;
      evento.target.value = '';
    },

    async validarArchivoSoltado(evento) {
      this.estaArrastrando = false;

      const archivos = evento.dataTransfer?.files;
      if (!archivos || archivos.length === 0) return;

      const archivo = archivos[0];
      const tipoMimeExcel =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const esExtensionValida = archivo.name.endsWith('.xlsx');

      if (archivo.type !== tipoMimeExcel && !esExtensionValida) {
        this.registrarError(
          -1,
          'Formato de archivo incorrecto. Solo se permiten archivos .xlsx',
          'Carga'
        );
        await alertWarning(
          '¡Formato no válido! Asegúrese de que sea un archivo Excel (.xlsx)'
        );
        return;
      }

      this.importacion.archivoExcel = archivo;
    },

    async procesarArchivo() {
      this.datos.empleadosSena = [];
      ConfigErr.timeToken();

      const formularioValido = this.$refs.formFile.validate();
      if (!formularioValido) return;

      this.limpiarErrores();
      this.importacion.loading = true;
      await this.obtenerBancos(true);
      await this.listarTiposNovedades();
      this.importacion.tieneCambiosPendientes = false;
      this.datos.empleadosCargados = [];
      this.datos.encabezadoCargado = [];

      try {
        const buffer = await this.importacion.archivoExcel.arrayBuffer();
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(buffer);

        const hojaEncabezado = workbook.worksheets[INDICE_HOJA_ENCABEZADO];
        const hojaEmpleados = workbook.worksheets[INDICE_HOJA_EMPLEADOS];
        const hojaNovedades = workbook.worksheets[INDICE_HOJA_NOVEDADES];

        if (!hojaEncabezado || !hojaEmpleados || !hojaNovedades) {
          await this.manejarErrorEstructura();
          return;
        }

        const datosEncabezadoJson = hojaAJson(hojaEncabezado);

        const empleadosImportadosJson = hojaAJson(hojaEmpleados);
        const datosNormalizados = normalizarDatosJson(
          empleadosImportadosJson,
          this.catalogos.mapaDocumentos,
          this.catalogos.mapaContratos
        );

        const novedadesImportadasJson = hojaAJson(hojaNovedades, 1);
        const novedadesNormalizadas = normalizarNovedadesJson(
          novedadesImportadasJson
        );

        this.$refs.formCompañia.reset();
        this.validarExcel(
          datosNormalizados,
          datosEncabezadoJson,
          novedadesNormalizadas
        );
      } catch {
        await alertWarning(
          'No se pudo abrir el archivo. Verifique que no haya sido movido y vuelva a cargarlo.'
        );

        this.eliminarArchivoCargado();
      }
    },

    async manejarErrorEstructura() {
      this.registrarError(
        -1,
        'El archivo no cumple con el formato o las hojas requeridas.',
        'Estructura'
      );

      await alertWarning('Estructura del archivo inválida');

      this.limpiarFormulario();
    },

    validarExcel(empleadosJson, encabezadoJson, novedadesNormalizadas) {
      if (!this.validarCompañia(encabezadoJson)) {
        this.registrarError(
          -1,
          'El archivo no coincide con la compañía y sucursal asociada al usuario'
        );
        return;
      }

      if (!empleadosJson.length) {
        this.registrarError(-1, 'Archivo sin registros');
        return;
      }

      const conteoDocumentos = this.construirConteoDocumentos(empleadosJson);
      const contexto = {
        tiposDocumentos: this.catalogos.tiposDocumentos,
        tiposContratos: this.catalogos.tiposContratos,
        bancos: this.catalogos.bancos,
        conteoDocumentos,
        mapas: {
          TipoDocumento: this.catalogos.mapaDocumentos,
          TipoContrato: this.catalogos.mapaContratos,
        },
      };

      const empleadosProcesados = empleadosJson.map((empleado, indiceFila) => {
        const {
          errores,
          empleado: empleadoProcesado,
          esSena,
        } = validarEmpleadoHelper(empleado, indiceFila + 2, contexto);

        errores.forEach(({ linea, detalle }) =>
          this.registrarError(linea, detalle, 'Empleados')
        );

        if (esSena) this.datos.empleadosSena.push(empleadoProcesado);

        return empleadoProcesado;
      });

      this.datos.empleadosCargados = empleadosProcesados;

      this.validarNovedades(novedadesNormalizadas);

      this.finalizarValidacionExcel(empleadosProcesados, encabezadoJson);
    },

    construirConteoDocumentos(empleadosJson) {
      const conteo = new Map();
      empleadosJson.forEach(empleado => {
        const numeroDocumento = empleado.NumeroDocumento;
        conteo.set(numeroDocumento, (conteo.get(numeroDocumento) ?? 0) + 1);
      });
      return conteo;
    },

    async finalizarValidacionExcel(empleadosProcesados, encabezadoJson) {
      if (this.importacion.errores.length > 0) {
        await alertWarning(
          'Se encontraron errores de diligenciamiento en el archivo plano.'
        );
        this.$refs.formFile.reset();
        return;
      }

      this.notificarEmpleadosSena();

      const empleadosSinSena = empleadosProcesados.filter(
        empleado => empleado.TipoContrato !== CONTRATO.APRENDIZAJE
      );

      this.validarCambios(empleadosSinSena, encabezadoJson);
    },

    notificarEmpleadosSena() {
      this.datos.empleadosSena.forEach(empleado => {
        this.importacion.errores.push({
          hoja: 'Empleados',
          linea: empleado.lineaExcel,
          detalle: `El empleado ${empleado.NumeroDocumento} ${
            empleado.nombreCompleto
          }, no será importado por su tipo de contrato: ${
            empleado.TipoContratoTexto || 'Aprendizaje'
          }`,
        });
      });
    },

    async validarCambios(empleadosJson, encabezadoJson) {
      this.importacion.tieneCambiosPendientes = true;
      const { Nit, IdSucursal } = encabezadoJson[0];

      const { data: empleadosGuardados } = await empleadosService.buscarTodos();

      this.aplicarBloqueoHeredado(empleadosGuardados, empleadosJson);
      this.procesarEmpleadosGuardados(
        empleadosGuardados,
        empleadosJson,
        Nit,
        IdSucursal
      );
      this.finalizarValidacionCambios(empleadosJson, encabezadoJson);
    },

    aplicarBloqueoHeredado(empleadosGuardados, empleadosJson) {
      const mapaGuardados = new Map(
        empleadosGuardados.map(empleado => [empleado.NumeroDocumento, empleado])
      );

      empleadosJson.forEach(empleado => {
        const guardado = mapaGuardados.get(empleado.NumeroDocumento);
        const debeBloquearse = guardado?.Bloqueado && !guardado.Embargo;
        if (debeBloquearse) empleado.Bloqueado = true;
      });
    },

    validarCompañia(encabezadoJson) {
      const { Nit } = encabezadoJson[0];
      return this.catalogos.nitsValidos.has(Nit);
    },

    procesarEmpleadosGuardados(
      empleadosGuardados,
      empleadosJson,
      Nit,
      IdSucursal
    ) {
      const mapaImportados = new Map(
        empleadosJson.map(empleado => [empleado.NumeroDocumento, empleado])
      );

      empleadosGuardados.forEach(guardado => {
        const importado = mapaImportados.get(guardado.NumeroDocumento);

        if (importado) {
          this.validarCambiosEmpleado(guardado, importado, Nit, IdSucursal);
          return;
        }

        this.registrarEmpleadoRetirado(guardado, Nit, IdSucursal);
      });
    },

    validarCambiosEmpleado(guardado, importado, Nit, IdSucursal) {
      const linea = importado.lineaExcel;

      const perteneceOtraEmpresa =
        guardado.NitCompañia !== Nit || guardado.IdSucursal !== IdSucursal;

      if (perteneceOtraEmpresa) {
        this.registrarError(
          linea,
          `El empleado ${guardado.NumeroDocumento} ${guardado.nombreCompleto}, Actualmente se encuentra registrado en otra compañía y/o sucursal. Validar si se realizó cesión de contrato`,
          'Empleados'
        );
      }

      if (importado.TipoContrato !== guardado.TipoContrato._id) {
        this.registrarError(
          linea,
          `El empleado ${guardado.NumeroDocumento} ${guardado.nombreCompleto}, tuvo cambios en el tipo de contratación`,
          'Empleados'
        );
      }

      if (importado.Salario !== guardado.Salario) {
        this.registrarError(
          linea,
          `El empleado ${guardado.NumeroDocumento} ${guardado.nombreCompleto}, tuvo cambios en el salario`,
          'Empleados'
        );
      }
    },

    registrarEmpleadoRetirado(guardado, Nit, IdSucursal) {
      const perteneceEstaEmpresa =
        guardado.NitCompañia === Nit &&
        guardado.IdSucursal === IdSucursal &&
        guardado.estaRetirado !== true;

      if (!perteneceEstaEmpresa) return;

      const aprendiz = this.datos.empleadosSena.find(
        sena => sena.NumeroDocumento === guardado.NumeroDocumento
      );

      this.importacion.errores.push({
        hoja: 'Empleados',
        linea: aprendiz ? aprendiz.lineaExcel : '--',
        detalle: `El empleado ${guardado.NumeroDocumento} - ${guardado.nombreCompleto} no aparece en el archivo enviado por la empresa. Por esta razón, será marcado como retirado en la plataforma. Te recomendamos confirmar esta novedad.`,
        dni: guardado.NumeroDocumento,
      });

      const yaRegistrado = this.datos.empleadosRetirados.some(
        retirado => retirado.NumeroDocumento === guardado.NumeroDocumento
      );

      if (!yaRegistrado) {
        this.datos.empleadosRetirados.push({
          NumeroDocumento: guardado.NumeroDocumento,
        });
      }
    },

    async finalizarValidacionCambios(empleadosJson, encabezadoJson) {
      this.datos.empleadosCargados = empleadosJson;
      this.datos.encabezadoCargado = encabezadoJson;

      if (this.importacion.errores.length === 0) {
        this.guardarEmpleados(empleadosJson, encabezadoJson);
        return;
      }

      this.importacion.loading = false;
      this.$refs.formFile.reset();
      await alertWarning(
        'Se detectaron cambios en los empleados. Verifiquelos para continuar con la importación.'
      );
    },

    validarNovedades(novedadesNormalizadas) {
      if (!novedadesNormalizadas.length) return;

      const empleadosImportados = new Set(
        this.datos.empleadosCargados.map(empleado => empleado.NumeroDocumento)
      );
      const contexto = {
        empleadosSet: empleadosImportados,
        mapas: { tipoNovedad: this.catalogos.mapaTiposNovedades },
      };

      const novedadesValidas = novedadesNormalizadas.filter(novedad => {
        const { errores } = validarNovedadHelper(
          novedad,
          novedad.lineaExcel,
          contexto
        );

        if (errores.length) {
          errores.forEach(({ linea, detalle }) =>
            this.registrarError(linea, detalle, 'Novedades')
          );
          return false;
        }
        return true;
      });

      this.datos.novedadesCargadas = novedadesValidas;
    },

    async descargarExcel() {
      ConfigErr.timeToken();

      if (!this.$refs.formCompañia.validate()) {
        return;
      }

      this.estaDescargando = true;

      await new Promise(resolve => setTimeout(resolve, 50));

      const { nit, razon_social: razonSocial } = this.seleccion.compañia;
      const {
        descripcion_sucursal: descripcionSucursal,
        sucursal_id: sucursalId,
      } = this.seleccion.sucursal;

      const informacionEncabezado = {
        Nit: String(nit),
        Compañia: razonSocial,
        Sucursal: descripcionSucursal,
        IdSucursal: sucursalId,
      };

      const fechaActual = moment().format('DD-MM-YYYY');
      const fileName = `Plano_Empleados_${descripcionSucursal}_${fechaActual}.xlsx`;

      const bancosOrdenados = [...this.catalogos.bancos].sort(
        (bancoA, bancoB) =>
          bancoA.codigo.localeCompare(bancoB.codigo, undefined, {
            numeric: true,
          })
      );

      await descargarPlantillaEmpleados({
        informacionEncabezado,
        bancos: bancosOrdenados,
        tiposNovedades: this.catalogos.tiposNovedades,
        fileName,
      });

      this.estaDescargando = false;
    },

    registrarError(linea, detalle, hoja = '') {
      this.importacion.loading = false;
      this.importacion.errores.push({ hoja, linea, detalle });
    },

    limpiarErrores() {
      this.importacion.errores = [];
    },

    limpiarFormulario() {
      this.importacion.loading = false;
      this.limpiarErrores();
      this.$refs.formFile.reset();
    },

    eliminarArchivoCargado() {
      this.importacion.archivoExcel = null;
      this.importacion.tieneCambiosPendientes = false;
      this.datos.empleadosCargados = [];
      this.datos.encabezadoCargado = [];
      this.datos.novedadesCargadas = [];
      this.limpiarErrores();

      if (this.$refs.formFile) {
        this.$refs.formFile.reset();
      }
    },
  },
};
</script>

<style scoped>
.mytableError td {
  height: 25px;
  font-size: 80%;
  border: 1px solid red;
}
.mytableError th {
  background-color: #ffcdd2;
  height: 25px;
  font-size: 80%;
  border: 1px solid red;
}
.mytableError td:not(:first-child) {
  border-left: none;
}
.mytableError th:first-child {
  border-top-left-radius: 8px;
}
.mytableError th:last-child {
  border-top-right-radius: 8px;
  border-left: none;
}
.mytableError tr:last-child td:first-child {
  border-bottom-left-radius: 8px;
}
.mytableError tr:last-child td:last-child {
  border-bottom-right-radius: 8px;
}

.dropzone-activa {
  transform: scale(0.99);
}

.lh-relaxed {
  line-height: 1.5;
}

.btn-eliminar-archivo .v-icon {
  color: #9e9e9e;
  transition: color 0.2s ease;
}

.btn-eliminar-archivo:hover .v-icon {
  color: #ef5350;
}

.btn-eliminar-archivo:disabled .v-icon {
  color: #bdbdbd;
}
</style>
